import React from 'react';
import { NavLink } from 'react-router-dom';

interface StatItemProps {
  index: number;
  value?: string;
  label: string;
  path?: string;
  disabled?: boolean;
}

export const StatItemRedesign = (props: StatItemProps) => {
  const { disabled } = props;

  const handleClick = (e: any) => {
    if (disabled) e.preventDefault();
  };

  return (
    <NavLink
      onClick={(e) => handleClick(e)}
      to={props.path ? props.path : '/'}
      activeStyle={{
        backgroundColor: '#2e4063',
        color: '#F7F7F7',
        fontWeight: 'bold',
      }}
      css={`
        padding: 0 40px;
        display: flex;
        align-items: center;
        height: 40px;
        background-color: #ebebeb;
        color: ${disabled ? '#B6B6B6' : '#2e4063'};
        border-width: 1px;
        border-color: #fff;
        border-right-style: solid;
        :first-child {
          border-top-left-radius: 25px;
        }
        :last-child {
          border-top-right-radius: 25px;
          border-right-style: none;
        }
        ${!disabled
          ? `
          :hover {
            color: #f7f7f7;
            cursor: pointer;
            background-color: #2e4063;
          }
        `
          : ''}
      `}
    >
      {props.value && (
        <>
          <span
            css={`
              font-weight: bold;
              margin-right: 4px;
            `}
          >
            {props.value ? props.value : 'empty'}
          </span>
          <span
            css={`
              font-weight: bold;
              margin-right: 4px;
            `}
          >
            ·
          </span>{' '}
        </>
      )}

      <span>{props.label ? props.label : 'empty'}</span>
    </NavLink>
  );
};
